// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on.
import { createFileRoute } from '@tanstack/react-router'
import { VerifyEmailScreen } from '../features/auth/VerifyEmailScreen'
import { text } from '../shared/routing/search'

export const Route = createFileRoute('/verify')({
  staticData: { screenId: 'AuthVerifyEmailScreen', access: 'pending verification' },
  // The route key's query arguments (screens.json `args`), as the apps' LinkResolver reads them;
  // unknown keys are dropped.
  validateSearch: (search: Record<string, unknown>): { email?: string; token?: string; next?: string } => ({
    email: text(search.email),
    token: text(search.token),
    // `?next=` is the route key's returnTo (spec 08 § 3); `?returnTo=` from links sent before it still works.
    next: text(search.next) ?? text(search.returnTo),
  }),
  component: AuthVerifyEmailScreen,
})

function AuthVerifyEmailScreen() {
  const { email, token, next } = Route.useSearch()
  return <VerifyEmailScreen email={email} token={token} returnTo={next} />
}
